/**
 * Конфигурация UI
 * Можно переопределить при подклчюении UI во Vue приложение через app.use(Core, options)
 */
const options = {
	widthForMobile: 900,
	dateFormat: 'Y-m-d',

	/**
	 * Для Москвы: +0300
	 */
	gmt: new Date().toString().match(/GMT(\S+)/)?.[1],
};

export default options;